import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';
import { UigVendorOrderSummaryComponent } from './uig-vendor-order-summary.component';

@NgModule({
    declarations: [UigVendorOrderSummaryComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        I18nModule,
        UrlModule,
        RouterModule
    ],
    exports: [
        UigVendorOrderSummaryComponent
    ],
    providers: [
        provideDefaultConfig({
            cmsComponents: {
                UigVendorOrderSummaryComponent: {
                    component: UigVendorOrderSummaryComponent
                }
            }
        } as CmsConfig | LayoutConfig),
    ]
})
export class UigVendorOrderSummaryModule { }
